export const GITHUB_ROLES = [
  {
    value: "read",
    key: "read",
    aliases: ["read", "pull"],
    label: "Read",
    description: "Can read and clone this repository. Can open issues and pull requests.",
    badgeClass: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800",
  },
  {
    value: "triage",
    key: "triage",
    aliases: ["triage"],
    label: "Triage",
    description: "Can read, clone, and manage issues and pull requests.",
    badgeClass: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
  },
  {
    value: "write",
    key: "write",
    aliases: ["write", "push"],
    label: "Write",
    description: "Can read, clone, and push commits to this repository.",
    badgeClass: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
  },
  {
    value: "maintain",
    key: "maintain",
    aliases: ["maintain"],
    label: "Maintain",
    description: "Can read, clone, push, and manage some repository settings.",
    badgeClass: "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-800",
  },
  {
    value: "admin",
    key: "admin",
    aliases: ["admin"],
    label: "Admin",
    description: "Full access to the repository, including settings and collaborators.",
    badgeClass: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800",
  },
];

// `value` is what the backend accepts (read, triage, write, maintain, admin); it maps them to GitHub's
// pull/push itself. `aliases` keep pull/push so access records GitHub returns still get the right label.
// The default must be an option `value` so the role Select shows it selected.
export const DEFAULT_GITHUB_ROLE = "write";

export function getRoleConfig(roleName) {
  if (!roleName) return null;
  const lower = String(roleName).toLowerCase();
  return (
    GITHUB_ROLES.find((r) => r.aliases.includes(lower)) || {
      value: lower,
      key: lower,
      aliases: [lower],
      label: roleName.charAt(0).toUpperCase() + roleName.slice(1),
      description: "",
      badgeClass: "bg-zinc-100 text-zinc-700 border-zinc-200 dark:bg-zinc-800 dark:text-zinc-300 dark:border-zinc-700",
    }
  );
}
